<footer class="main-footer">
    <div class="container-dynamic d-flex">
      <span class="m-auto"></span>
      Designed and Developed by <a href="https://varuna-sentinels.com/" target="_blank" rel="noopener">&nbsp;Varuna Sentinels BV</a>
    </div>
    <!-- Company regulatory statement (about Varuna Sentinels B.V., not about supplier data). Hidden while its config is empty. -->
    <div *ngIf="esmaStatement" class="container-dynamic d-flex" style="font-size: 11px; opacity: 0.75; line-height: 1.4;">
      <span class="m-auto"></span>
      <span>
        {{ 'COMPANY_STATEMENT.ESMA' | translate: { date: esmaStatement.date, lei: esmaStatement.lei } }}
        <a [href]="esmaStatement.url" target="_blank" rel="noopener noreferrer">{{ 'COMPANY_STATEMENT.ESMA_LINK' | translate }}</a>
      </span>
    </div>
  </footer>